import { BASE } from '@/types/utils/sizesType';

import { SocialProfileType } from '@/types/socialProfileType';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';

const SocialProfileCell = ({ socialProfile }: { socialProfile: SocialProfileType }) => {
    return (
        <div className="group relative">
            <Avatar
                fallback={socialProfile.slug[0]}
                url={socialProfile.external_api_data?.avatar}
                profileType={socialProfile.social_network_type}
                size={BASE}
            />
            <div className="absolute left-full top-1/2 ml-1 hidden max-w-[200px] -translate-y-1/2 overflow-hidden rounded-m border border-white bg-white/80 px-3 py-1 font-GSemiBold text-xs text-icoBlue shadow-icoXL backdrop-blur-md group-hover:flex firefox:bg-white firefox:bg-opacity-95 dark:border-icoDarkMode-deepBlack dark:bg-icoDarkMode-deepBlack/80 dark:firefox:bg-icoDarkMode-deepBlack dark:firefox:bg-opacity-95">
                <span className="block truncate">{socialProfile.slug}</span>
            </div>
        </div>
    );
};

export default SocialProfileCell;
